import { domains } from 'config/env'

export const WELCOME_TEXT = `You're in, `
export const MAIN_TEXT = 'Your next step is to assign each license to a school'
export const SECOND_TEXT = `Once licenses are assigned, you'll be able to connect educators to the program`
export const LICENSE_MANAGEMENT_PATH = `${domains.ADMIN_DOMAIN}/license-management`
export const FAQ_LINK = `https://support.secondstep.org/hc/en-us/articles/360023610733-I-am-a-setup-administrator-What-does-that-mean-`
